function selectCompany (obj) {
  this.setState({ selectedCompany: obj })
  window.localStorage.setItem('app.companyId', obj.ts_id)
  window.location.reload()
}

export default selectCompany
